export const environment = {
  firebaseConfig: {
    apiKey: "AIzaSyDCvRyexevBXNh8LuUxvWIdA2WBW2BHMUE",
    authDomain: "creative-cat-88a2b.firebaseapp.com",
    projectId: "creative-cat-88a2b",
    storageBucket: "creative-cat-88a2b.firebasestorage.app",
    messagingSenderId: "20398387804",
    appId: "1:20398387804:web:eaa5b631942c81a4322c99",
    measurementId: "G-TJ4ED002FK"
  },
  production: true,
  apiUrl: "https://api.kocur.ai/api/",
  firebaseApiUrl: "https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyDCvRyexevBXNh8LuUxvWIdA2WBW2BHMUE"
};